/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
import { Link, navigate } from "@reach/router";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
import firebase from "gatsby-plugin-firebase"
import { useAuth } from '../../services/use-auth';

// @material-ui/icons
import { Apps, CloudDownload } from "@material-ui/icons";

// React icons
import { FaTwitter, FaFacebook, FaInstagram, FaKeycdn } from 'react-icons/fa';

import { ImLocation } from 'react-icons/im'
import { MdEvent } from 'react-icons/md'
import { IoMdAlbums } from 'react-icons/io'

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";

import headerLinksStyle from "assets/jss/material-kit-react/components/headerLinksStyle.jsx";

const logout = () => {
  firebase.auth().signOut();
};

function HeaderLinks({ ...props }) {
  const { classes } = props;

  const auth = useAuth();

  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <Link to="/MembersArea/Profile"
          className={classes.navLink}
        >
          <FaKeycdn className={classes.icons} /> Members Area
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to="/Album"
          className={classes.navLink}
        >
          <IoMdAlbums className={classes.icons} /> Albums
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to="/Events"
          className={classes.navLink}
        >
          <MdEvent className={classes.icons} /> Events
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText="Information"
          buttonProps={{
            className: classes.navLink,
            color: "transparent"
          }}
          buttonIcon={Apps}
          dropdownList={[
            <Link to="/Information/News" className={classes.dropdownLink} state={{ feedURL: "420intel.com/taxonomy/term/469/feed", feedType: "feed" }}>
              Cannabis News
            </Link>,
            <Link to="/Information/Education" className={classes.dropdownLink} state={{ feedURL: "medicalmarijuana411.com/feed", feedType: "feed" }}>
              Cannabis Education
          </Link>,
            <Link to="/Information/Fun" className={classes.dropdownLink} state={{ feedURL: "https://www.chef-420.com/rss/all.xml", feedType: "xml" }}>
              Cannabis Fun
        </Link>,
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to="/ContactUS"
          className={classes.navLink}
        >
          <ImLocation className={classes.icons} /> Contact Us
        </Link>
      </ListItem>

      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-facebook"
          title="Follow us on facebook"
          placement={typeof window !== 'undefined' && window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://www.facebook.com/rooftop420"
            target="_blank"
            className={classes.navLink}
          >
            <FaFacebook />
          </Button>
        </Tooltip>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-tooltip"
          title="Follow us on instagram"
          placement={typeof window !== 'undefined' && window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://www.instagram.com/_rooftop420/"
            target="_blank"
            className={classes.navLink}
          >
            <FaInstagram />
          </Button>
        </Tooltip>
      </ListItem>
    </List>
  );
}

export default withStyles(headerLinksStyle)(HeaderLinks);
